import { cva } from 'class-variance-authority';

// remove upon UI section revamp
export const buttonVariants = cva('button-base', {
  variants: {
    variant: {
      default: 'bg-transparent text-black hover:bg-light-grey',
      destructive:
        'bg-destructive text-destructive-foreground hover:bg-destructive/90',
      outline:
        'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
      secondary: 'secondary-button',
      ghost: 'ghost-button bg-transparent',
      light: 'secondary-button bg-transparent',
      link: 'text-primary underline-offset-4 hover:underline',
      yellow: 'yellow-button',
      success:
        'text-black bg-success active:bg-success/80 hover:shadow-md border border-green-mid',
      sidebar: 'bg-sidebar text-secondary-foreground hover:bg-white',
      icon: 'rounded-full bg-white hover:bg-light-grey/60 active:translate-y-[0.5px] border border-light-grey',
    },
    size: {
      default: 'button-size',
      xs: 'h-5 px-2',
      sm: 'h-9 px-3',
      lg: 'h-12 px-8',
      icon: 'h-10 w-10',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
});
